/* eslint-disable react/prop-types */
import React from 'react';
import { Card, CardBody, CardHeader, Collapse, Button } from 'reactstrap';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';

export class Accordion extends React.Component {
  state = {
    open: []
  };

  toggleSection = index => () => {
    const existIndex = this.state.open.some(openStateIndex => openStateIndex === index);
    const indexInState = this.state.open.find(openIndex => openIndex === index);
    const updatedOpenArray = existIndex
      ? this.state.open.filter(indexState => indexState !== indexInState)
      : [...this.state.open, index];
    this.setState({
      open: updatedOpenArray
    })
  };

  render() {
    return (
      <div className="accordion">
        {React.Children.map(this.props.children, (child, index) => {
          if (child.type !== AccordionItem) return null;
          return React.cloneElement(child, {
            isOpen: this.props.isFixed ? true : !!(this.state.open.some(indexState => indexState === index)),
            onClick: this.toggleSection(index)
          });
        })}
      </div>
    );
  }
}

const AccordionItem = ({ children, isOpen, onClick }) => (
  <Card>
    {React.Children.map(children, child => {
      if (child.type === AccordionBody) {
        return React.cloneElement(child, { isOpen });
      }
      if (child.type === AccordionHeader) {
        return React.cloneElement(child, { onClick, isOpen });
      }
      return null;
    })}
  </Card>
);

const AccordionHeader = ({ children, onClick, isOpen, isShowDropDown }) => (
  <CardHeader className="summaryAccordion">
    <h5>
      <Button className="buttonAccordion" color="transaprent" onClick={onClick}>
        {children}
        {isShowDropDown ? isOpen ? <FaChevronUp /> : <FaChevronDown /> : null}
      </Button>
    </h5>
  </CardHeader>
);

const AccordionBody = ({ children, isOpen, isFixed }) => (
  <Collapse isOpen={isOpen}>
    <CardBody className="read-only">
      {children}
    </CardBody>
  </Collapse>
);

Accordion.Item = AccordionItem;
Accordion.Header = AccordionHeader;
Accordion.Body = AccordionBody;
